import React from "react";
import { SidebarIcons } from "../StandardContentSidebar/SidebarIcons";

const homemenu = [
  {
    uri: "/home",
    label: "Dashboard",
    type: "nav-item",
    icon: SidebarIcons.HomeIcon,
  },
];
export default homemenu;
